const getVideoNameFromUrl = (url) => {
  if (!url) return '';

  const urlToArr = url.split('/');
  return urlToArr[urlToArr.length - 1];
};

export default getVideoNameFromUrl;
